export const REQUEST_INTERLINE_OPERATORS = "REQUEST_INTERLINE_OPERATORS";
export const RECEIVE_INTERLINE_OPERATORS = "RECEIVE_INTERLINE_OPERATORS";

export const requestInterlineOperators = () => ({
  type: REQUEST_INTERLINE_OPERATORS
});

export const receiveInterlineOperators = payload => ({type: RECEIVE_INTERLINE_OPERATORS, payload: payload});


// WEBPACK FOOTER //
// ./src/actions/interlineOperatorsActions.js